import { useAuth } from "@project/contexts/AuthContext";
import Dashboard from "@project/pages/Dashboard";
import InterviewerDashboard from "@project/pages/InterviewerDashboard";
import CandidateDashboard from "@project/pages/CandidateDashboard";
import { getCandidateAccessToken } from "@project/services/CandidateAuthService";

export function RoleDashboard() {
  const { user } = useAuth();

  // Real candidate logged in via CandidateAuthService (token in localStorage)
  if (getCandidateAccessToken()) {
    return <CandidateDashboard />;
  }

  switch (user?.role) {
    case "interviewer":
      return <InterviewerDashboard />;
    case "candidate":
      return <CandidateDashboard />;
    default: // admin, hr
      return <Dashboard />;
  }
}
